import { KLAGE_MILJOKONTROLL_THUMBNAIL_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageMiljoKontrollThumbnailImageReducer = (
  state = INITIAL_STATE,
  action,
) => CreateNewReducer(state, action, KLAGE_MILJOKONTROLL_THUMBNAIL_IMAGE);

export default klageMiljoKontrollThumbnailImageReducer;
